import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { colour } from './design/tokens.ts';

const style = document.createElement('style');
style.textContent = `
  *, *::before, *::after { box-sizing: border-box; }
  html, body { margin: 0; padding: 0; }
  body {
    background: ${colour.ground};
    color: ${colour.ink};
    font: 400 15px/22px 'IBM Plex Sans', system-ui, sans-serif;
    -webkit-font-smoothing: antialiased;
  }
  /* Nothing relies on colour alone, and nothing relies on a focus ring the
     browser might not draw: this one is always visible. */
  :focus-visible { outline: 3px solid ${colour.accent}; outline-offset: 2px; }
  button { font-family: inherit; }
  a { color: ${colour.link}; }
  code { font-family: 'IBM Plex Mono', ui-monospace, monospace; }
  @keyframes maestro-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.55; } }
  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after { animation-duration: 0.01ms !important; animation-iteration-count: 1 !important; }
  }
`;
document.head.appendChild(style);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
